import { SchedulePicker } from '@/components/composer/SchedulePicker';

/**
 * ScheduleSection Component
 *
 * Date/time picker for scheduling posts
 */

interface ScheduleSectionProps {
  scheduledTime: Date | null;
  onScheduleChange: (time: Date | null) => void;
  disabled: boolean;
  /** When true, stack date and time vertically (for narrow containers) */
  compact?: boolean;
}

export const ScheduleSection = ({
  scheduledTime,
  onScheduleChange,
  disabled,
  compact = false,
}: ScheduleSectionProps) => {

  return (
    <div>
      <SchedulePicker
        scheduledTime={scheduledTime}
        onScheduleChange={onScheduleChange}
        disabled={disabled}
        directMode={true}
        compact={compact}
      />
    </div>
  );
};
